import { TranslateModule } from '@ngx-translate/core';
import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { CheckInReasonDialogComponent } from './check-in-reason-dialog.component';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BillingBannerComponent } from 'src/app/components/billing-banner/billing-banner.component';
import { SetupGuideComponent } from 'src/app/components/setup-guide/setup-guide.component';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar
interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-full',
  imports: [
    TranslateModule,
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
    CustomizerComponent,
    BillingBannerComponent,
    SetupGuideComponent,
  ],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class FullComponent implements OnInit {
  navItems = navItems;

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  // for mobile app sidebar
  apps: apps[] = [

    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'eCommerce App',
      subtitle: 'Buy a Product',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/apps/invoice',
    },
    {
      id: 4,
      img: '/assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/apps/calendar',
    },
    {
      id: 5,
      img: '/assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/apps/contacts',
    },
    {
      id: 6,
      img: '/assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/apps/tickets',
    },
    {
      id: 7,
      img: '/assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/apps/email/inbox',
    },
    {
      id: 8,
      img: '/assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/apps/courses',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/theme-pages/pricing',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/authentication/login',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/authentication/side-register',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/authentication/error',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/apps/notes',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/apps/employee',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/apps/todo',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/theme-pages/treeview',
    },
  ];

  constructor(
    private settings: CoreService,
    private mediaMatcher: MediaMatcher,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    private coreService: CoreService,
    private http: HttpClient
  ) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[BELOWMONITOR];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.content.scrollTo({ top: 0 });
      });
  }

  user: any;
  hasArrived = false;
  punching = false;
  warehouseId!: number;
  /** El check-in de hoy espera aprobación (se marcó fuera de la facility o sin GPS). */
  checkInPending = false;
  checkInFacility = '';

  private dialog = inject(MatDialog);

  ngOnInit(): void {
    this.user = this.coreService.getUserInfoFromToken();

    if (!this.user) return;

    this.warehouseId = this.user.WarehouseID;

    this.loadTodayStatus();
  }
  loadTodayStatus() {
    // Sin warehouse en el token, el API usa el principal de la persona y dice cuál es.
    this.http.get<any>(`${environment.apiUrl}/DriverPunch/today?warehouseId=${this.warehouseId || 0}`)
      .subscribe({
        next: res => {
          this.hasArrived = res?.hasArrival && !res?.hasDeparture;
          if (res?.warehouseId) this.warehouseId = res.warehouseId;
          this.checkInFacility = res?.warehouseName || '';
          this.checkInPending =
            (this.hasArrived && res?.arrivalStatus === 'PendingApproval') ||
            (!this.hasArrived && res?.departureStatus === 'PendingApproval');
        },
        error: () => { /* el botón sigue funcionando */ },
      });
  }

  get checkInTooltip(): string {
    const action = this.hasArrived ? 'Check out' : 'Check in';
    const where = this.checkInFacility ? ` at ${this.checkInFacility}` : '';
    return this.checkInPending ? `${action}${where} · today's check-in is waiting for approval` : `${action}${where}`;
  }

  /**
   * Check in / Check out. Manda la ubicación (si el navegador la da) sin motivo. Si el API dice que está fuera de la
   * facility, sin GPS o que la facility no tiene ubicación (409 NeedsReason), pide el motivo y lo vuelve a mandar:
   * queda guardado y cuenta para el pago cuando el dueño o un Admin lo apruebe. Ya no manda "Arrived" solo.
   */
  async onPunch() {
    if (!this.user || this.punching) return;

    this.punching = true;
    const punchType: 'Arrival' | 'Departure' = this.hasArrived ? 'Departure' : 'Arrival';

    try {
      let coords: GeolocationCoordinates | null = null;
      try {
        coords = (await this.getLocation()).coords;
      } catch {
        coords = null; // sin permiso o sin señal: el API pide el motivo
      }

      const body: any = {
        warehouseId: this.warehouseId,
        punchType,
        latitude: coords?.latitude ?? null,
        longitude: coords?.longitude ?? null,
        accuracyMeters: coords?.accuracy ?? null,
      };

      let res: any;
      try {
        res = await firstValueFrom(this.http.post(`${environment.apiUrl}/DriverPunch`, body));
      } catch (err: any) {
        if (err?.status !== 409 || err?.error?.code !== 'NeedsReason') throw err;

        const reason = await firstValueFrom(
          this.dialog.open(CheckInReasonDialogComponent, {
            data: { message: err.error.message, punchType, why: err.error.why },
            autoFocus: 'textarea',
          }).afterClosed()
        );
        if (!reason) return;

        res = await firstValueFrom(this.http.post(`${environment.apiUrl}/DriverPunch`, { ...body, notes: reason }));
      }

      this.hasArrived = punchType === 'Arrival';
      this.checkInPending = res?.status === 'PendingApproval';
      this.coreService.showSuccess(
        res?.message || (punchType === 'Arrival' ? 'Checked in.' : 'Checked out.')
      );
    } catch (err: any) {
      this.coreService.showError(err?.error?.message || 'Could not check in. Try again.');
    } finally {
      this.punching = false;
    }
  }
  getLocation(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        reject,
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0
        }
      );
    });
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.toggleDarkTheme(options);
    this.toggleColorsTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  toggleColorsTheme(options: AppSettings) {
    // Remove any existing theme class dynamically
    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith('_theme')) {
        this.htmlElement.classList.remove(className);
      }
    });

    // Add the selected theme class
    this.htmlElement.classList.add(options.activeTheme);
  }

  get isCompanyOnboarding(): boolean {
    return this.router.url
      .toLowerCase()
      .includes('/register-company-owner');
  }
}
